import { Component } from '@angular/core';

@Component({
  selector: 'app-sub-code',
  templateUrl: './sub-code.component.html',
  styleUrls: ['./sub-code.component.scss'],
  standalone: false
})
export class SubCodeComponent {
}
